import ErrorPage from '@/components/ErrorBoundary/ErrorPage'

import { RouteObject } from 'react-router-dom'
import { DocumentCreate } from './components/Create'
import ListDocuments from './components/List'
import ShareDocuments from './components/Share'
import { DocumentUpdate } from './components/Update'
import ApproveDocument from './components/Approved'

const DocumentModule: RouteObject = {
    path: 'documents',
    children: [
        {
            path: '',
            element: <ListDocuments />,
        },
        {
            path: 'share',
            element: <ShareDocuments />,
        },
        {
            path: 'new',
            element: <DocumentCreate />,
        },
        {
            path: ':documentID',
            children: [
                {
                    path: 'edit',
                    element: <DocumentUpdate />,
                },
            ],
        },
        {
            path: 'approved',
            element: <ApproveDocument />,
        },
    ],
    errorElement: <ErrorPage status={500} />,
}
export default DocumentModule
